import { render, staticRenderFns } from "./DeliveryFilter.vue?vue&type=template&id=188b3aaa&scoped=true&"
import script from "./DeliveryFilter.vue?vue&type=script&lang=js&"
export * from "./DeliveryFilter.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryFilter.vue?vue&type=style&index=0&id=188b3aaa&lang=scss&scoped=true&"
import style1 from "./DeliveryFilter.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188b3aaa",
  null
  
)

export default component.exports